export default __webpack_public_path__ + "static/media/Dark-uploadVDO.693311fb.svg";